// extracted by mini-css-extract-plugin
export var box = "_6j-1";
export var checked = "_6j-2";
export var descriptionSpacer = "_6j-9";
export var disabled = "_6j-3";
export var icon = "_6j-6";
export var input = "_6j-0";
export var labelSpacer = "_6j-8";
export var medium = "_6j-5";
export var small = "_6j-4";
export var text = "_6j-7";